import React, { useState, useEffect } from 'react';
import { useAuth, API_URL, Currency, DateBR } from '../contexts/AuthContext';
import { Plus, AlertCircle, Barcode, Clock } from 'lucide-react';

export default function Estoque() {
  const { token } = useAuth();
  const [low, setLow] = useState<any[]>([]);
  const [movements, setMovements] = useState<any[]>([]);
  const [open, setOpen] = useState(false);
  const [type, setType] = useState('entry');
  const [form, setForm] = useState({ product_id: '', quantity: '', unit_cost: '', reason: '' });

  useEffect(() => {
    if (!token) return;
    fetch(`${API_URL}/stock/low-stock`, { headers: { Authorization: `Bearer ${token}` } }).then(r => r.json()).then(d => setLow(d)).catch(() => {});
    fetch(`${API_URL}/stock`, { headers: { Authorization: `Bearer ${token}` } }).then(r => r.json()).then(d => setMovements(d)).catch(() => {});
  }, [token]);

  const save = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const endpoint = type === 'loss' ? '/loss' : type === 'adjust' ? '/adjust' : '/entry';
      const body: any = { product_id: form.product_id, quantity: form.quantity, reason: form.reason };
      if (type === 'entry') body.unit_cost = form.unit_cost;
      const r = await fetch(`${API_URL}/stock${endpoint}`, { method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }, body: JSON.stringify(body) });
      if (!r.ok) { const j = await r.json().catch(() => ({})); setMsg(j.error || 'Erro'); setMsgType('err'); return; }
      const j = await r.json();
      setMsg(j.message || 'Registrado'), setMsgType('ok');
      setOpen(false);
      fetch(`${API_URL}/stock/low-stock`, { headers: { Authorization: `Bearer ${token}` } }).then(r => r.json()).then(d => setLow(d)).catch(() => {});
      fetch(`${API_URL}/stock`, { headers: { Authorization: `Bearer ${token}` } }).then(r => r.json()).then(d => setMovements(d)).catch(() => {});
    } catch { setMsg('Erro interno'), setMsgType('err'); }
  };
  const [msg, setMsg] = useState('');
  const [msgType, setMsgType] = useState<'ok'|'err'>('ok');

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Estoque</h1>
          <p className="text-gray-600">Movimentações, ajustes e alertas de estoque</p>
        </div>
        <button onClick={() => setOpen(true)} className="btn-primary"><Plus size={18} /> Movimentar</button>
      </div>
      {msg && <div className={`rounded-lg p-3 text-sm ${msgType === 'ok' ? 'bg-green-50 border border-green-200 text-green-700' : 'bg-red-50 border border-red-200 text-red-700'}`}>{msg}</div>}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="card">
          <h2 className="text-sm font-semibold text-gray-700 mb-3"><AlertCircle size={16} className="mr-2" /> Estoque baixo</h2>
          <div className="space-y-2">
            {low.map(p => (
              <div key={p.id} className="flex items-center justify-between py-2 border-b border-gray-100 last:border-0">
                <div>
                  <div className="font-medium text-sm">{p.name}</div>
                  <div className="text-xs text-gray-500">{p.brand || ''} · {p.stock_quantity} em estoque</div>
                </div>
                <div className="text-right"><span className="badge badge-warn">{p.min_stock} mín.</span></div>
              </div>
            ))}
            {low.length === 0 && <p className="text-xs text-gray-500 text-center py-4">Sem produtos abaixo do mínimo</p>}
          </div>
        </div>
        <div className="card">
          <h2 className="text-sm font-semibold text-gray-700 mb-3"><Clock size={16} className="mr-2" /> Últimas movimentações</h2>
          <div className="space-y-2">
            {movements.slice(0,10).map(m => (
              <div key={m.id} className="flex items-center justify-between py-2 text-sm border-b border-gray-100 last:border-0">
                <div className="flex items-center gap-2">
                  <span className={`badge ${m.type === 'entry' ? 'badge-ok' : m.type === 'loss' ? 'badge-danger' : 'badge-warn'}`}>{m.type}</span>
                  <span className="text-gray-600">{m.product_name}</span>
                </div>
                <div className="text-right">{m.quantity >= 0 ? '+' : ''}{m.quantity} un</div>
              </div>
            ))}
          </div>
        </div>
      </div>
      {open && (
        <div className="fixed inset-0 z-50 bg-black/60 flex items-center justify-center">
          <div className="bg-white rounded-2xl p-6 w-full max-w-md shadow-xl">
            <h2 className="text-lg font-bold text-gray-900 mb-4">Movimentação de estoque</h2>
            <form onSubmit={save} className="space-y-3">
              <div>
                <label className="text-xs font-medium text-gray-500 block mb-1">Tipo</label>
                <select className="input" value={type} onChange={e => setType(e.target.value)}>
                  <option value="entry">Entrada</option><option value="adjust">Ajuste</option><option value="loss">Perda/quebra</option>
                </select>
              </div>
              <div><label className="text-xs font-medium text-gray-500 block mb-1">Produto</label><input className="input" value={form.product_id} onChange={e => setForm({ ...form, product_id: e.target.value })} placeholder="ID do produto" required /></div>
              <div><label className="text-xs font-medium text-gray-500 block mb-1">Quantidade</label><input className="input" type="number" step="0.001" value={form.quantity} onChange={e => setForm({ ...form, quantity: e.target.value })} required /></div>
              {type === 'entry' && (
                <div><label className="text-xs font-medium text-gray-500 block mb-1">Custo unitário (R$)</label><input className="input" type="number" step="0.01" value={form.unit_cost} onChange={e => setForm({ ...form, unit_cost: e.target.value })} required /></div>
              )}
              <div><label className="text-xs font-medium text-gray-500 block mb-1">Motivo / justificativa</label><input className="input" value={form.reason} onChange={e => setForm({ ...form, reason: e.target.value })} required /></div>
              <div className="flex justify-end gap-2 pt-4">
                <button type="button" onClick={() => setOpen(false)} className="btn-ghost px-4">Cancelar</button>
                <button className="btn-primary">Registrar</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
